module.exports = __webpack_public_path__ + "static/royale-new-7c2fb8c0dff535c6cedfa57d74dacd07.png";